import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { ResponseObject } from 'src/app/models/response-object.model';
import { SaleResponse } from 'src/app/models/sale.model';
import { SalesService } from 'src/app/services/sales.service';

import { AuthenticationService } from '../../authentication/authentication/authentication.service';

@Component({
  selector: 'app-history-annul-sales',
  templateUrl: './history-annul-sales.component.html',
  styleUrls: ['./history-annul-sales.component.scss']
})
export class HistoryAnnulSalesComponent implements OnInit {

  invoices: SaleResponse[] = [];

  loadingData = false;

  waitingFor: SaleResponse | null = null;
  seeingAnulate = false;
  anulating = false;

  cancelledDescription = '';

  pagination = {
    total: [],
    filter: [],
    pageSize: 10,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };

  constructor(
    private saleService: SalesService,
    private toastService: ToastrService,
    private authService: AuthenticationService
  ) {

  }

  ngOnInit(): void {
    this.getInvoicesToAnul();
  }

  getInvoicesToAnul(): void {

    this.loadingData = true;

    this.saleService
      .getClientInvoicesToAnulInFiscal()
      .subscribe({
        next: (response: ResponseObject) => {

          this.invoices = response.data ?? [];

          this.invoices.sort((a: any, b: any) => {

            const dateA = new Date(a.date ?? 0).getTime();
            const dateB = new Date(b.date ?? 0).getTime();

            if (dateB !== dateA) {
              return dateB - dateA;
            }

            return Number(b.id ?? 0) - Number(a.id ?? 0);
          });

          this.pagination.total = this.invoices;
          this.resetPagination();

          this.loadingData = false;
        },

        error: (error: HttpErrorResponse) => {

          console.error(error);

          this.toastService.error(
            error.error?.message ??
            'Error al obtener las facturas pendientes de anulación'
          );

          this.loadingData = false;
        }
      });
  }

  anulateInvoice(invoice: SaleResponse): void {
    this.waitingFor = invoice;
    this.cancelledDescription = '';
    this.seeingAnulate = true;
  }

  cancelAnulation(): void {
    this.waitingFor = null;
    this.cancelledDescription = '';
    this.seeingAnulate = false;
  }

  confirmCanceledInvoice(): void {

    if (!this.waitingFor || this.anulating) {
      return;
    }

    if (!this.cancelledDescription.trim()) {
      this.toastService.info(
        'Debes ingresar una razón para la anulación'
      );
      return;
    }

    this.anulating = true;

    this.saleService
      .cancelInvoice(
        this.waitingFor,
        this.cancelledDescription.trim()
      )
      .subscribe({

        next: (response: ResponseObject) => {

          this.toastService.success(
            'Se ha completado la cancelación!'
          );

          const invoiceId = this.waitingFor?.id;

          this.invoices = this.invoices.filter(
            invoice => invoice.id !== invoiceId
          );

          this.pagination.total = this.invoices;
          this.resetPagination();

          this.waitingFor = null;
          this.cancelledDescription = '';
          this.seeingAnulate = false;
          this.anulating = false;
        },

        error: (error: any) => {

          console.error(error);

          if (error.error?.data?.description) {
            this.toastService.error(
              error.error.data.description
            );
          } else {
            this.toastService.error(
              error.error?.message ??
              'Error al anular Factura'
            );
          }

          this.anulating = false;
        }
      });
  }

  resetPagination(): void {

    this.pagination.filter =
      this.pagination.total.slice(
        0,
        this.pagination.pageSize
      );

    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.lastElement =
      this.pagination.filter.length;
  }

  convertToString(date: any): string {

    if (!date) {
      return '';
    }

    const tempDate = new Date(date);

    const day = String(tempDate.getDate()).padStart(2, '0');
    const month = String(tempDate.getMonth() + 1).padStart(2, '0');
    const year = tempDate.getFullYear();

    return `${day}/${month}/${year}`;
  }

  getFixedName(name: string): string {

    if (!name) {
      return '';
    }

    return name
      .replace(/,+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  getInvoiceTotal(invoice: any): number {

    return Number(invoice.totalCost ?? 0) +
           Number(invoice.totalTaxes ?? 0) +
           Number(invoice.totalExtraTax ?? 0);
  }

}